module.exports = __webpack_public_path__ + "img/fig3.809c32f8.png";